import { parse } from "graphql";
import { SchemaClient } from "../../../common/GraphqlClient";
import {
  DynamoDbOperations,
  DynamoDbTables,
  Source,
} from "../../../common/Source";
import { User } from "./Users";
import { EMPTY_VALUE } from "../../../Schema";


export type Group = {
  groupName: string;
  userIds?: User[];
  reviewers?: User[];
}

type ListGroupsVariables = {
  groupName: { eq: string };
  nextToken?: string;
}

export const listGroupsQuery: Source<Group[], ListGroupsVariables> = {
  graphql: parse(`
    query listIRGroupAdminMappings(
      $nextToken: String,
      $filter: ModelIRGroupAdminMappingFilterInput,
      $groupName: ModelStringKeyConditionInput,
    ) {
      listIRGroupAdminMappings(
        limit: 10000,
        nextToken: $nextToken,
        filter: $filter,
        groupName: $groupName,
        modelName: "IRGroupAdminMapping"
      ) {
        items {
          groupName
          userIds {
            email
            familyName
            givenName
            name
            userId
          }
          reviewers {
            email
            familyName
            givenName
            name
            userId
          }
        }
        nextToken
      }
    }
  `),
  dynamodb: {
    operation: DynamoDbOperations.QUERY,
    table: DynamoDbTables.GROUPS,
    // groupName is the table's sort key, so the exact-match the GraphQL side expresses as a
    // key condition argument is a key condition here too, not a filter.
    keyCondition: ({ groupName }) => ({
      expression: "#modelName = :modelName AND #groupName = :groupName",
      names: { "#modelName": "modelName", "#groupName": "groupName" },
      values: { ":modelName": "IRGroupAdminMapping", ":groupName": groupName.eq },
    }),
  },
};

export const getGroups = async (client: SchemaClient, groupName: string): Promise<Group[] | typeof EMPTY_VALUE> => {
  return await client.queryList(listGroupsQuery, {
    groupName: { eq: groupName }
  });
};

export const getAndProcessGroups = async (client: SchemaClient, groupName: string): Promise<Group[]> => {
  const groups = await getGroups(client, groupName);
  return groups?.map((group: Group) => ({
    groupName: group.groupName,
    userIds: group.userIds?.map((user: User) => ({
      email: user.email,
      familyName: user.familyName,
      givenName: user.givenName,
      name: user.name,
      site: user.site,
      userId: user.userId
    })) ?? [],
    reviewers: group.reviewers?.map((reviewer: User) => ({
      email: reviewer.email,
      familyName: reviewer.familyName,
      givenName: reviewer.givenName,
      name: reviewer.name,
      site: reviewer.site,
      userId: reviewer.userId
    })) ?? []
  })) ?? [];
}